import React from 'react'
import Layout from './Layout'
import ButtonWithLoader from './ButtonWithLoader'

const LessonFinishedScreen: React.FC = () => {
  const handleReturnHome = () => {
    window.location.href = '/'
  }

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow-2xl p-8 text-center">
          <div className="mb-6">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
              <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Lesson Completed!</h2>
          <p className="text-gray-600 mb-8">Thank you for completing the lesson. Great job!</p>
          <ButtonWithLoader
            onClick={handleReturnHome}
            label="Return to Home"
            customClass="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition duration-200"
          />
        </div>
      </div>
    </Layout>
  )
}

export default LessonFinishedScreen
